import { createApiRequest } from "@/lib/api/createApiService";
import { SETTINGS_ENDPOINTS } from "./settings.endpoints";

export const settingsService = {
  checkUnique: async (payload = {}, options = {}) => {
    return createApiRequest({
      url: SETTINGS_ENDPOINTS.CHECK_UNIQUE,
      method: "POST",
      body: payload,
      ...options,
    });
  },

  updateProfile: async (payload = {}, options = {}) => {
    return createApiRequest({
      url: SETTINGS_ENDPOINTS.UPDATE_PROFILE,
      method: "PATCH",
      body: payload,
      ...options,
    });
  },
};
